"use client"

import { useReportWebVitals } from "next/web-vitals"

// TODO: Implement this component to report web vitals to a analytics service
// https://nextjs.org/docs/app/building-your-application/optimizing/analytics
// https://nextjs.org/docs/app/building-your-application/optimizing/analytics#sending-results-to-external-systems
export const WebVitals = () => {
  useReportWebVitals((metric) => {
    console.debug("metric", metric)
  })
  return <></>
}
